import {HTTP_STATUS_NOTFOUND, HTTP_STATUS_UNAUTHORIZED} from '../../smartpak/httpstatus.js';

function getUserLoginInfoPromise() {
    return $.get('/account/getUserlogininfo');
}

function requiresAuthentication(response) {
    return response && response.IsLoggedIn;
}

function requiresReAuthentication(response) {
    return response && response.IsLoggedIn && !response.ReAuthorizationRequired;
}

function makeCallbackDecision(expressionCallback, authenticated, notAuthenticated) {
    return function (response) {
        var callback = expressionCallback(response) ? authenticated : notAuthenticated;

        if (typeof callback === 'function') {
            callback();
        }
    };
}
function elementRequires(dataString) {
    return function ($element) {
        var data = $element.dataset[dataString];

        return typeof data !== 'undefined' && data === 'true';
    };
}

const authentication = {
    elementRequiresAuthentication: elementRequires('authorize'),
    elementRequiresReAuthentication: elementRequires('reauthorize'),
    checkIfAuthenticationIsRequired: function (authenticated, notAuthenticated) {
        getUserLoginInfoPromise().done(makeCallbackDecision(requiresAuthentication, authenticated, notAuthenticated));
    },
    checkIfReAuthenticationIsRequired: function (authenticated, notAuthenticated) {
        getUserLoginInfoPromise().done(makeCallbackDecision(requiresReAuthentication, authenticated, notAuthenticated));
    },
    logout: function (callback) {
        return $.get('/account/logout').done(function (response) {
            if (response.logOutSuccessful && typeof callback === 'function') {
                callback();
            }
        });
    },
    resultIsUnauthorized: function (result) {
        const INDEX_NOT_FOUND = -1;

        if (result.status && (result.status === HTTP_STATUS_UNAUTHORIZED || result.status === HTTP_STATUS_NOTFOUND)) {
            return true;
        }

        return result.Redirect && result.Redirect.toLowerCase().indexOf('login') !== INDEX_NOT_FOUND;
    },
    checkResponseForAuthorization: function (response, callingFunc, callback) {
        if (!response || typeof callingFunc !== 'function' || typeof callback !== 'function') {
            return;
        }

        if (authentication.resultIsUnauthorized(response)) {
            authentication._launchModal({
                success: callingFunc
            });
            return;
        }

        callback(response);
    },
    checkAuthenticatedThenLaunchLoginOrExecuteTask: function (authenticated, options) {
        this.checkIfAuthenticationIsRequired(authenticated, () => {
            var opts = {
                success: authenticated
            };

            this._launchModal(options ? $.extend(opts, options) : opts);
        });
    },
    checkReAuthenticatedThenLaunchLoginOrExecuteTask: function (authenticated, notAuthenticated) {
        this.checkIfReAuthenticationIsRequired(authenticated, () => {
            this._launchModal({
                success: authenticated,
                fail: notAuthenticated
            });
        });
    },
    handleAuthenticationCheckClick: function ($link, callback) {
        if ($link && typeof callback === 'function') {
            var success = () => callback($link),
                fail = () => {
                    this._launchModal({
                        success: () => callback($link),
                        redirectURL: $link.href,
                        payPal: $link.dataset.paypal
                    });
                };

            if (this.elementRequiresReAuthentication($link)) {
                this.checkIfReAuthenticationIsRequired(success, fail);
                return;
            }

            if (this.elementRequiresAuthentication($link)) {
                this.checkIfAuthenticationIsRequired(success, fail);
            }
        }
    },
    _launchModal: function (options) {
        import('./launchmodal').then(({default: launchModal}) => launchModal(options));
    }
};

export default authentication;
